export class UpdateCredentialsProfileInput {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "aws",
            "baseName": "aws",
            "type": "CreateCredentialsProfileInputAws",
            "format": ""
        },
        {
            "name": "gcp",
            "baseName": "gcp",
            "type": "CreateCredentialsProfileInputGcp",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return UpdateCredentialsProfileInput.attributeTypeMap;
    }
    constructor() {
    }
}
